import getAppointmentKinds from './getAppointmentKinds';

export { getAppointmentKinds };
